export default __webpack_public_path__ + "static/media/steps-passenger.607cbb89.svg";